export default "__VITE_ASSET__CjfieAUH__"